import { Tag } from "antd";
import { CrownOutlined, UserOutlined } from "@ant-design/icons";


export const listRoleAccount = [
  {
    label: "Quản trị",
    value: "admin",
    tag: (
      <Tag color="gold" className="flex items-center gap-1 mr-0">
        <CrownOutlined />
        Quản trị
      </Tag>
    ),
  },
  {
    label: "Người dùng",
    value: "user",
    tag: (
      <Tag color="blue" className="flex items-center gap-1 mr-0">
        <UserOutlined />
        Người dùng
      </Tag>
    ),
  },
];

